import { motion } from "framer-motion";
import React from "react";

interface PrimaryButtonProps {
  onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  onPress?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  label?: string | React.ReactNode;
  title?: string | React.ReactNode;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  className?: string;
  size?: "large" | "small";
  variant?: "standard" | "outline" | "ghost";
  disabled?: boolean;
  [key: string]: any;
}

export const PrimaryButton = ({
  onClick,
  onPress,
  label,
  title,
  leftIcon,
  rightIcon,
  className = "",
  size = "large",
  variant = "standard",
  disabled = false,
  ...props
}: PrimaryButtonProps) => {
  const isSmall = size === "small";
  const hasNoIcons = !leftIcon && !rightIcon;
  const clickHandler = onClick || onPress;
  const buttonLabel = label ?? title;

  const getVariantClasses = () => {
    if (disabled) {
      switch (variant) {
        case "outline":
          return "bg-white border border-gray-200 text-gray-400 cursor-not-allowed";
        case "ghost":
          return "bg-transparent text-gray-400 cursor-not-allowed";
        case "standard":
        default:
          return "bg-gray-100 text-gray-400 cursor-not-allowed";
      }
    }

    switch (variant) {
      case "outline":
        return "bg-white border border-gray-300 text-gray-700";
      case "ghost":
        return "bg-transparent text-gray-600 hover:text-gray-900 hover:bg-gray-100";
      case "standard":
      default:
        // return "bg-[#0e1c7a] text-white hover:bg-[#020637] shadow-sm";
        return "bg-[#020637] text-white hover:bg-[#0f1a6d] shadow-sm";
    }
  };

  return (
    <motion.button
      whileHover={disabled ? undefined : { scale: 1.06 }}
      whileTap={disabled ? undefined : { scale: 0.98 }}
      onClick={clickHandler}
      disabled={disabled}
      className={`
        flex
        items-center
        transition-colors
        whitespace-nowrap
        flex-shrink-0
        ${hasNoIcons ? "justify-center" : ""}
        ${getVariantClasses()}
        ${isSmall ? "px-3 py-1.5 text-sm rounded-lg gap-1.5" : "px-4 py-2.5 text-base rounded-xl gap-2"}
        ${className}
      `}
      {...props}
    >
      {leftIcon}
      {buttonLabel}
      {rightIcon}
    </motion.button>
  );
};
